import { authFetch } from './client';

export const getLicenseStatus = () => authFetch('/api/license/status');
export const activateLicense = (licenseKey) =>
  authFetch('/api/license/activate', { method: 'POST', body: JSON.stringify({ licenseKey }) });
export const removeLicense = () => authFetch('/api/license', { method: 'DELETE' });
